module.exports = __webpack_public_path__ + "img/live12.071ac919.png";